export default __webpack_public_path__ + "static/media/redhat.9ef2ec50.svg";